import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getMessage(c,id)
  {
    const url = apiUrl + 'Message/View/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getMessageCount()
  {
    const url = apiUrl + 'getMessageCount';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data.count
    }
  },


};

export default {
  namespaced: true,
  actions
}